// extracted by mini-css-extract-plugin
module.exports = {"root":"yFP4UOvQ","flexRowWrapper":"S6KNDCTZ","currencyLabel":"nkBdq944"};